import avatar1 from '../assets/images/avatar1.jpg';
import avatar2 from '../assets/images/avatar2.jpg';
import avatar3 from '../assets/images/avatar3.jpg';
import avatar4 from '../assets/images/avatar4.jpg';
import avatar5 from '../assets/images/avatar5.jpg';
import Bob from '../assets/images/bob.jpg';

const dataDescription = [
  {
    id: 1,
    titre: 'Wooden terrace installation',
    description:
      'I want to install a wooden terrace on an existing concrete terrace',
    details: 'Heavy load',
    time: 'Available on weekends',
    img: Bob,
    name: 'Bob le bricoleur',
    ville: 'Nantes',
    category: 'exterior',
    vote: '⭐⭐⭐⭐',
  },
  {
    id: 2,
    titre: 'Installation of a staircase',
    description:
      "Hello, I'm looking for someone to help me install my new stairs.",
    details: 'Precision, heavy load',
    time: 'Next week',
    img: avatar1,
    name: 'Julie',
    ville: 'Paris',
    category: 'interior',
    vote: '⭐⭐⭐⭐⭐',
  },
  {
    id: 3,
    titre: 'Installation of tiles',
    description:
      'I have started to install my carelage by myself in my kitchen, but the result is not conclusive, I am looking for someone who can help me to finish please?',
    details: 'Precision,',
    time: 'Avaible the week-end',
    img: avatar2,
    name: 'Mano Tchao',
    ville: 'Vertou',
    category: 'exterior',
    vote: '⭐⭐⭐⭐',
  },
  {
    id: 4,
    titre: 'Hedge trimming',
    description:
      'I am looking for someone to trim my hedges properly, thank you! ',
    details: 'Heavy load, available all week',
    time: 'Today',
    img: avatar3,
    name: 'Julien',
    ville: 'Saint-Sebastien',
    category: 'garden',
    vote: '⭐⭐⭐⭐',
  },
  {
    id: 5,
    titre: 'Replace a bathtub',
    description:
      'Need help to replace my bathtub! if anyone is available within a week? ',
    details: 'Heavy load',
    time: 'Avaible all week',
    img: avatar4,
    name: 'Mat',
    ville: 'Toulouse',
    category: 'bathroom',
    vote: '⭐⭐⭐⭐',
  },
  {
    id: 6,
    titre: 'Wooden terrace installation',
    description:
      'I want to install a wooden terrace on an existing concrete terrace',
    details: 'Heavy load',
    time: 'Available on weekends',
    img: avatar5,
    name: 'Boby la bricole',
    ville: 'Nantes',
    category: 'garden',
    vote: '⭐⭐⭐⭐',
  },
];

export default dataDescription;
